import React, { useEffect, useRef } from 'react';
import { Form, Input, DatePicker, Checkbox } from '@ss/mtd-react';
import { observer } from 'mobx-react-lite';
import { useSetState } from 'ahooks';
import { Select } from '@block/plug';
import cloneDeep from 'lodash/cloneDeep';
import { useRootStore } from '@src/model';
import { getEnumByCategory, getCompanyEnum } from '@service/resumeDetail';
import ModuleView from '../../ModuleView';

interface FilterStatus {
  [key: string]: any;
}

const FormItem = Form.Item;

function WorkExperience(props) {
  const formRefs = useRef<any[]>([]);
  const { type, data } = props;
  const { campusResumeDetail, socialResumeDetail, socialResumeFormRefStore, campusResumeFormRefStore } = useRootStore();
  // 判断所有notMessage是'无数据' or '请输入'
  const [filterStatus, setFilterStatus] = useSetState<FilterStatus>({});

  let store;
  let storeRef;
  if (type === 'campus') {
    store = campusResumeDetail;
    storeRef = campusResumeFormRefStore;
  }
  if (type === 'social') {
    store = socialResumeDetail;
    storeRef = socialResumeFormRefStore;
  }

  useEffect(() => {
    storeRef.changeRef('resumeWorkExpListRef', formRefs.current);
    const cloneData = cloneDeep(data);
    cloneData?.map((item, index) => {
      formRefs.current[index]?.setFieldsValue({
        endDate: item.endDate === 253370736000000 ? 0 : item.endDate,
      });
      return null;
    });
  }, [data, data?.length]);

  const handleValueChange = (index: string, formItemKey: string, formItemValue: any) => {
    switch (formItemKey) {
      case 'companyName': {
        store.setResumeWorkExpList(index, 'companyName', formItemValue?.name ? formItemValue.name : '');
        store.setResumeWorkExpList(index, 'companyId', formItemValue?.id ? formItemValue.id : '');
        break;
      }
      case 'workTypeName': {
        store.setResumeWorkExpList(index, 'workTypeName', formItemValue?.name ? formItemValue.name : '');
        store.setResumeWorkExpList(index, 'workType', formItemValue?.id ? formItemValue.id : '');
        break;
      }
      default:
        store.setResumeWorkExpList(index, formItemKey, formItemValue);
    }
  };

  const handleFetchData = async (category: string, filter?: string, index?: number) => {
    if (!filter) {
      setFilterStatus({ [`${category}-${index}`]: null });
    }
    let res;
    if (category === 'company') res = await getCompanyEnum({ filter });
    else {
      res = await getEnumByCategory({ category });
    }
    setFilterStatus({ [`${category}-${index}`]: filter });
    return res;
  };

  return (
    <div className="work_experience_edit model_edit">
      <div className="model_title">
        工作/实习经历{type === 'campus' && <span className="experience_tips">请填写可提供实习证明的实习经历</span>}
      </div>
      {data?.map((item, index) => (
        <div className="model_list" key={item.renderId}>
          <Form
            ref={(el) => {
              formRefs.current[index] = el;
            }}
            className="modal_form"
            defaultFieldsValue={item}
            onFieldValueChange={(formItemKey, formItemValue) => handleValueChange(index, formItemKey, formItemValue)}
          >
            <FormItem formItemKey="companyName" span="11" labelWidth={0} required message="请填写公司名称">
              <div className="label">
                公司名称<span className="icon">*</span>
              </div>
              <Select
                toFormItem
                size="large"
                placeholder="请选择"
                labelField="name"
                keyField="id"
                notFoundMessage={filterStatus?.[`company-${index}`] ? '无数据' : '请输入'}
                onFetchData={(filter) => handleFetchData('company', filter, index)}
              />
            </FormItem>
            <FormItem
              formItemKey="department"
              span="11"
              labelWidth={0}
              rules={[
                {
                  type: 'string',
                  max: 100,
                  message: '部门名称不能超过100字',
                },
              ]}
            >
              <div className="label">部门名称</div>
              <Input toFormItem size="large" placeholder="请输入部门名称" maxLength={100} />
            </FormItem>
            <FormItem formItemKey="position" span="11" labelWidth={0} required message="请填写职位名称">
              <div className="label">
                职位名称<span className="icon">*</span>
              </div>
              <Input toFormItem size="large" placeholder="请输入职位名称" maxLength={20} />
            </FormItem>
            <FormItem formItemKey="workTypeName" span="11" labelWidth={0} required message="请填写工作类型">
              <div className="label">
                工作类型<span className="icon">*</span>
              </div>
              <Select
                toFormItem
                size="large"
                placeholder="请选择"
                labelField="name"
                keyField="id"
                notFoundMessage={filterStatus?.[`workType-${index}`] ? '无数据' : '请输入'}
                onFetchData={() => handleFetchData('workType', undefined, index)}
              />
            </FormItem>
            <FormItem
              className="form_item_start_date"
              formItemKey="startDate"
              span="4"
              labelWidth={0}
              required
              message="请填写开始时间"
            >
              <div className="label">
                在职时间<span className="icon">*</span>
              </div>
              <DatePicker
                toFormItem
                size="large"
                format="YYYY/MM"
                valueFormat="timestamp"
                placeholder="在开始时间"
                disabledDate={(cur) => {
                  if (item?.endDate) return cur > item.endDate;
                  return false;
                }}
              />
              <div className="inner-line" />
            </FormItem>
            <FormItem
              className="form_item_end_date"
              formItemKey="endDate"
              span="3"
              labelWidth={0}
              required
              message="请填写结束时间"
            >
              <div className="label"> </div>
              <DatePicker
                disabled={store.resumeWorkExpList[index].endDate === 253370736000000}
                toFormItem
                size="large"
                format="YYYY/MM"
                valueFormat="timestamp"
                placeholder="结束时间"
                disabledDate={(cur) => {
                  if (item?.startDate) return cur < item.startDate;
                  return false;
                }}
              />
            </FormItem>

            <FormItem className="form_item_up_to_now" formItemKey="upToNow" span="1" labelWidth={0}>
              <div className="label"> </div>
              <Checkbox
                checked={store.resumeWorkExpList[index].endDate === 253370736000000}
                onChange={(e) => {
                  if (e.target.checked) {
                    store.setResumeWorkExpList(index, 'endDate', 253370736000000);
                    formRefs.current[index]?.setFieldsValue({ endDate: 0 });
                    formRefs.current[index]?.validateFields(['endDate']);
                  } else {
                    store.setResumeWorkExpList(index, 'endDate', '');
                    formRefs.current[index]?.setFieldsValue({ endDate: '' });
                  }
                }}
              >
                至今
              </Checkbox>
            </FormItem>
            <FormItem formItemKey="workDescription" span="11" labelWidth={0}>
              <div className="label">工作描述</div>
              <Input.TextArea
                className="input_text_area"
                toFormItem
                placeholder="请输入工作描述"
                maxLength={2000}
                showCount
                autosize={{ minRows: 2, maxRows: 6 }}
              />
            </FormItem>
          </Form>
          <div className="delete-list">
            <div onClick={() => store.deleteResumeList('resumeWorkExpList', index)}>删除这段经历</div>
          </div>
        </div>
      ))}

      <div className="list_add" onClick={() => store.addResumeList('resumeWorkExpList')}>
        <div className="add_icon">
          <img src={require('@imgs/add.svg')} alt="" />
        </div>
        添加工作/实习经历
      </div>
    </div>
  );
}

export default ModuleView(observer(WorkExperience), 'workExperience');
